import styled from "styled-components"
import { Taxo } from "gatsby-theme-blank/src/components/Home/Actualites/ActuItem/actu-item-styled"

const ActualiteTitle = styled.h3`
  color: ${(props) => props.theme.c_color_gradients.c_dark};
  & a {
    ${(props) => props.theme.c_color_gradients.c_dark};
  }
`

const ActualiteResume = styled.p`
  color: ${(props) => props.theme.c_color_gradients.c_dark};
`

export { Taxo, ActualiteResume, ActualiteTitle }
